import { OverviewAccordion } from '../ComponentsOverview/OverviewAccordion';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FeedbackCircle } from '@/components/shared/FeedbackCircle';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { abyssColors } from '@/theme/colors';
import { useFilterCviAndGviPois } from '../hooks/useFilterCviAndGviPois';
import { feedbackContainerStyles } from '../DetailsGrid/styles';

export const PoiSection = () => {
  const { allPois, loading, headers } = useFilterCviAndGviPois();

  return (
    <Stack direction="column" gap="2rem" sx={{ width: '100%' }}>
      {allPois &&
        !loading &&
        allPois.length > 0 &&
        allPois.map((pois, groupIndex) => {
          return (
            <OverviewAccordion
              key={groupIndex}
              title={pois.title}
              defaultExpanded={pois.data.length > 0}
              details={
                <>
                  {pois.data.length > 0 ? (
                    <Grid
                      container
                      direction="column"
                      sx={{ width: '100%', p: '4rem', pt: '1.4rem' }}
                    >
                      <Grid
                        size={{ xs: 12 }}
                        sx={{ border: `0.1rem solid ${abyssColors.primary[100]}` }}
                      >
                        <Grid container>
                          {headers.map((header, index) => (
                            <Grid
                              key={`header-${index}`}
                              size={{ xs: 12 / headers.length }}
                              sx={{
                                px: '0.8rem',
                                py: '0.8rem',
                                borderRight:
                                  index !== headers.length - 1
                                    ? `0.1rem solid ${abyssColors.primary[100]}`
                                    : 'none',
                                borderBottom: `0.1rem solid ${abyssColors.primary[100]}`,
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  fontWeight: 700,
                                  fontSize: '1.2rem',
                                  color: abyssColors.primary[500],
                                }}
                              >
                                {header}
                              </Typography>
                            </Grid>
                          ))}
                        </Grid>

                        {pois.data.map((row, rowIndex) => (
                          <Grid
                            container
                            key={`row-${rowIndex}`}
                            sx={{
                              borderBottom:
                                rowIndex !== pois.data.length - 1
                                  ? `0.1rem solid ${abyssColors.primary[100]}`
                                  : 'none',
                            }}
                          >
                            {headers.map((key, colIndex) => (
                              <Grid
                                key={`cell-${rowIndex}-${colIndex}`}
                                size={{ xs: 12 / headers.length }}
                                sx={{
                                  px: '0.8rem',
                                  py: '0.8rem',
                                  borderRight:
                                    colIndex !== headers.length - 1
                                      ? `0.1rem solid ${abyssColors.primary[100]}`
                                      : 'none',
                                }}
                              >
                                <Typography
                                  variant="body1"
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: '1.2rem',
                                    color: abyssColors.primary[500],
                                  }}
                                >
                                  {row[key]}
                                </Typography>
                              </Grid>
                            ))}
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ) : (
                    <Box sx={feedbackContainerStyles} data-testid="feedback-circle">
                      <FeedbackCircle
                        backgroundColor="none"
                        text="No data available to show"
                        textColor={abyssColors.primary[300]}
                        icon={<AbyssIcon iconName="fallback-component-overview" size="2xl" />}
                      />
                    </Box>
                  )}
                </>
              }
            />
          );
        })}
    </Stack>
  );
};
